import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Annulé : {{reason}}',
    fulfilled: 'Cette commande a été exécutée avec succès',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Non accepté',
    [OrderRejectionReason.ClosingSoon]: 'Fermeture prochaine',
    [OrderRejectionReason.ItemUnavailable]: 'Article indisponible',
    [OrderRejectionReason.OrderTooBig]: 'Commande trop importante',
    [OrderRejectionReason.CustomerMistake]: 'Erreur du client',
    [OrderRejectionReason.Other]: 'Autre',
    fully_refunded: 'La commande a été entièrement remboursée',
  },
};
